import React, { Component } from 'react';
import { connect } from 'react-redux';
import SeferListesiDetails from "./SeferListesiDetails";
import SeferTescilBilgisiDetails from "./SeferTescilBilgisiDetails";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

const gridOptions = {
    sizePerPage: 10,
    paginationSize: 4,  // the pagination bar size.
    prePage: 'Prev', // Previous page button text
    nextPage: 'Next', // Next page button text
    firstPage: 'First', // First page button text
    lastPage: 'Last', // Last page button text
    prePageTitle: 'Previous',
    nextPageTitle: 'Next',
    firstPageTitle: 'First',
    lastPageTitle: 'Last',
    paginationPosition: 'bottom',
    hideSizePerPage: true,
    expandRowBgColor: 'gray'
};

class SeferListesi extends Component {
    isExpandableRow(row) {
        return true;
    }

    expandComponent(row) {
        return (
            <div>
                <SeferTescilBilgisiDetails data={row.TescilKayitlari}/>
                <SeferListesiDetails data={row.details}/>
                </div>
        );
    }

    expandColumnComponent({ isExpandableRow, isExpanded }) {
        let content = '';

        if (isExpandableRow) {
            content = (isExpanded ? '-' : '+');
        } else {
            content = ' ';
        }
        return (
            <div> {content} </div>
        );
    }

render() {
    const { seferler } = this.props;

    return (
        <BootstrapTable data={seferler}
            pagination={true} options={gridOptions}
            maxHeight={320}
            striped
            hover
            condensed
            exportCSV

            expandableRow={this.isExpandableRow}
            expandComponent={this.expandComponent}
            expandColumnOptions={{
                expandColumnVisible: true,
                expandColumnComponent: this.expandColumnComponent,
                columnWidth: 50
            }}
        >
            <TableHeaderColumn dataField='id' isKey={true} width="150px" hidden>ID</TableHeaderColumn>
            <TableHeaderColumn dataField="GemiAdi" title="Gemi" width="150px">Gemi</TableHeaderColumn>
            <TableHeaderColumn dataField="SeferNumarasi" title="Sefer Numarası" width="150px">Sefer Numarası</TableHeaderColumn>
            <TableHeaderColumn dataField="GumrukKodu" title="Gümrük" width="100px">Gümrük</TableHeaderColumn>
            <TableHeaderColumn dataField="Kumpanya" title="Line" width="100px">Line</TableHeaderColumn>
            <TableHeaderColumn dataField="GerceklesenGelisTarih" title="Geliş Tarihi" width="100px">Geliş Tarihi</TableHeaderColumn>
            <TableHeaderColumn dataField="GerceklesenKalkisTarih" title="Kalkış Tarihi" width="100px" >Kalkış Tarihi</TableHeaderColumn>
            <TableHeaderColumn dataField="TescilNumarasi"  title="Tescil Numarası" width="170px">Tescil Numarası</TableHeaderColumn>
            <TableHeaderColumn dataField="AmbarOnayTarihi" title="Ambar Onay" width="100px">Ambar Onay</TableHeaderColumn>
            <TableHeaderColumn dataField="GumrukOnayTarihi" title="Gümrük Onay" width="100px">Gümrük Onay</TableHeaderColumn>
        </BootstrapTable>
    );
}
}

const mapStateToProps = state => ({
    seferler: state.reducer.seferler
});

export default connect(mapStateToProps)(SeferListesi);


// WEBPACK FOOTER //
// ./src/components/containers/SeferListesi.js